import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnInit
}                           from '@angular/core';
import {
  Observable,
  Subject
}                           from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { HaynesProGroupsModel }          from '../typings/haynes-pro.groups';
import { HaynesProLaborTimeModel }       from '../typings/haynes-pro.labor-time';
import { HaynesProRepairSubjectModel }   from '../typings/haynes-pro.repair-subject';
import { HaynesProService }              from '../haynes-pro.service';
import { HaynesProServiceIntervalModel } from '../typings/haynes-pro.service-interval';
import { MessagesService }               from '../../messages/messages.service';
import { VehicleModel }                  from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool-section',
  template: require('./haynes-pro.diagnostic-tool.section.component.html')
})
export class HaynesProDiagnosticToolSectionComponent implements OnInit {

  @Input() groups       : HaynesProGroupsModel;
  @Input() isActive     : boolean;
  @Input() subCategories: Array<string>;
  @Input() vehicle      : VehicleModel;

  activeTab         : any                                  = 0;
  laborTimeRemoved$ : Subject<HaynesProLaborTimeModel>     = new Subject<HaynesProLaborTimeModel>();
  laborTimeRemoved  : Observable<HaynesProLaborTimeModel>  = this.laborTimeRemoved$.asObservable();
  repairSubjects    : Array<HaynesProRepairSubjectModel>   = [];
  serviceIntervals  : Array<HaynesProServiceIntervalModel> = [];

  constructor (
    @Inject(forwardRef(() => HaynesProService))
    private haynesProService : HaynesProService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    private translateService : TranslateService,
  ) {}

  ngOnInit() {
    this.haynesProService.getServiceIntervals(this.vehicle)
    .then(( intervals : Array<HaynesProServiceIntervalModel> ) => {
      this.serviceIntervals = intervals;

      return this.haynesProService.getRepairSubjects(this.vehicle);
    })
    .then(( subjects : Array<HaynesProRepairSubjectModel> ) => {
      this.repairSubjects = subjects;
    })
    .catch(err => this.messagesService.error(err));
  }

  getSubCategoryTitle ( subCategory: string ): string {
    switch (subCategory) {
      case 'ADJUSTMENTS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ADJUSTMENTS');
      case 'ALL':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ALL');
      case 'CASES':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.CASES');
      case 'DRAWINGS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.DRAWINGS');
      case 'EOBD_LOCATIONS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.WIRING_DIAGRAMS');
      case 'FUSE_LOCATIONS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.FUSE_LOCATIONS');
      case 'LUBRICANTS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.LUBRICANTS');
      case 'LOCATIONS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.LOCATIONS');
      case 'MAINTENANCE':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.MAINTENANCE');
      case 'RECALLS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.RECALLS');
      case 'REPAIR_TIMES':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.REPAIR_TIMES');
      case 'STORIES':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.STORIES');
      case 'TSB':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.TSB');
      case 'VESA':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.VESA');
      case 'WARNING_LIGHTS':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.WARNING_LIGHTS');
      default:
        return subCategory;
    }
  }

}